<template>
    <div class="table-wrapper">
        <table>
            <thead>
                <tr>
                    <th>设备名称</th>
                    <th>报警时间</th>
                    <th>报警类型</th>
                </tr>
            </thead>
            <tbody v-if="rows.length">
                <tr :title="row.id" style="cursor: pointer;" v-for="(row, index) in rows" :key="index" @click="handleClick(row)">
                    <td>{{ row.id }}</td>
                    <td>{{ row.failDate }}</td>
                    <td>{{ row.info }}</td>
                </tr>
            </tbody>
        </table>
        <div class="tipsText" v-if="!rows.length">当前没有设备报警</div>
    </div>
</template>
  
  <script>
export default {
    name: 'ScrollableTable',
    props: {
        columns: {
            type: Array,
            required: true
        },
        rows: {
            type: Array,
            required: true
        }
    },
    methods: {
        handleClick(e) {
            this.$emit('handleClick', e);
        }
    }
};
</script>
  
  <style lang="less" scoped>
.table-wrapper {
    overflow-x: auto;
    overflow-y: scroll;
    width: 100%;
    height: 100%;
    font-weight: bold;
}
.table-wrapper::-webkit-scrollbar {
    width: 0;
    height: 0;
}

table {
    border-collapse: collapse;
    width: 100%;

    th {
        position: sticky;
        top: 0;
        background-color: #27a2d3;
        z-index: 1;
        width: 33%;
        text-align: center;
    }

    th,
    td {
        padding: 0.1rem;
        text-align: center;
        border-bottom: 1px solid #ddd;
    }
    th {
        border-bottom: 0;
    }
}
.tipsText {
    color: #fff;
    font-weight: bold;
    text-align: center;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    padding-top: 0.5rem;
}
</style>
  